import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-24 bg-white relative overflow-hidden" data-id="element-107">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full overflow-hidden pointer-events-none" data-id="element-108">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-orange-50 rounded-full blur-3xl opacity-50" data-id="element-109"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-110">
        <div className="max-w-3xl mx-auto text-center" data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight" data-id="element-112">
            Comience su transformación hoy mismo
          </h2>

          <p className="text-xl text-gray-700 mb-12 leading-relaxed" data-id="element-113">
            Hoy puede acceder al protocolo completo para reactivar su energía y
            proteger su longevidad por un pago único.{' '}
            <strong className="text-gray-900" data-id="element-114">
              Sin suscripciones, sin trampas.
            </strong>{' '}
            Solo salud real por el precio de un café.
          </p>

          <div className="bg-white rounded-3xl shadow-2xl border-2 border-orange-100 p-8 md:p-12 mb-10 relative" data-id="element-115">
            {/* Badge */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-orange-600 text-white px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wider shadow-lg" data-id="element-116">
              Oferta Especial
            </div>

            <div className="mb-8" data-id="element-117">
              <p className="text-gray-500 font-medium uppercase tracking-wider mb-2" data-id="element-118">
                Inversión Única
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-119">
                <span className="text-6xl md:text-7xl font-extrabold text-gray-900" data-id="element-120">
                  $6.39
                </span>
                <span className="text-2xl text-gray-500 font-medium mt-4" data-id="element-121">
                  USD
                </span>
              </div>
            </div>

            <div className="space-y-4 mb-10 text-left max-w-sm mx-auto mt-4" data-id="element-122">
              <div className="flex items-center gap-3" data-id="element-123">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-124" />
                <span className="text-gray-700 font-medium" data-id="element-125">
                  Guía Principal (PDF)
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-126">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-127" />
                <span className="text-gray-700 font-medium" data-id="element-128">
                  Protocolo de 24 Horas
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-129">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-130" />
                <span className="text-gray-700 font-medium" data-id="element-131">
                  Lista de Compras USA
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-132">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-133" />
                <span className="text-gray-700 font-medium" data-id="element-134">
                  Checklist de Re-encendido
                </span>
              </div>
            </div>

            <div id="cta-final" className="scroll-mt-24" data-id="element-135">
              <CTAButton className="max-w-lg" href="https://www.contenidodigitalpro.com/cart/47374729052309:1" data-id="element-136" />
            </div>
          </div>

          <p className="text-sm text-gray-500" data-id="element-137">
            Al hacer clic en el botón, será redirigido a nuestra página de pago
            seguro.
          </p>
        </div>
      </div>
    </section>;
}